// 代理商权限
export const AgentPermissions = [
  {
    icon: "raffle",
    name: "权益工具",
    componentPath: "/points-calculator",
    type: "MENU",
    sortNo: 1,
    parentId: 0,
    id: 1,
    children: [
      {
        icon: "raffle",
        name: "积分计算器",
        componentPath: "/points-calculator/index.vue",
        path: "/points-calculator/index",
        type: "MENU",
        sortNo: 1,
        parentId: 1,
        id: 10,
      },
    ],
  },
  {
    icon: "store",
    name: "账户分润",
    componentPath: "/account-profit",
    type: "MENU",
    sortNo: 2,
    parentId: 0,
    id: 2,
    children: [
      {
        icon: "brand",
        name: "账户分润订单",
        componentPath: "/account-profit/index.vue",
        path: "/account-profit/index",
        type: "MENU",
        sortNo: 1,
        parentId: 2,
        id: 20,
      }
    ]
  },
  {
    icon: "order",
    name: "下级管理",
    componentPath: "/subordinate-management",
    type: "MENU",
    sortNo: 3,
    parentId: 0,
    id: 3,
    children: [
      {
        icon: "order",
        name: "下级列表",
        componentPath: "/subordinate-management/list.vue",
        path: "/subordinate-management/list",
        type: "MENU",
        sortNo: 1,
        parentId: 3,
        id: 30,
      },
    ],
  },
  {
    icon: "order",
    name: "合伙人管理",
    componentPath: "/partner-management",
    type: "MENU",
    sortNo: 3,
    parentId: 0,
    id: 5,
    children: [
      {
        icon: "order",
        name: "合伙人列表",
        componentPath: "/partner-management/list.vue",
        path: "/partner-management/list",
        type: "MENU",
        sortNo: 1,
        parentId: 3,
        id: 30,
      },
    ],
  },
  {
    icon: "newsCenter",
    name: "收款方式",
    componentPath: "/payment-method",
    type: "MENU",
    sortNo: 4,
    parentId: 0,
    id: 4,
    children: [
      {
        icon: "newsCenter",
        name: "收款列表",
        componentPath: "/payment-method/payment-list.vue",
        path: "/payment-method/payment-list",
        type: "MENU",
        sortNo: 1,
        parentId: 4,
        id: 40,
      },
    ],
  },
  {
    icon: "newsCenter",
    name: "代理商管理",
    componentPath: "/agent-management",
    type: "MENU",
    sortNo: 5,
    parentId: 0,
    id: 5,
    children: [
      {
        icon: "newsCenter",
        name: "下级代理列表",
        componentPath: "/agent-management/list.vue",
        path: "/agent-management/list",
        type: "MENU",
        sortNo: 1,
        parentId: 5,
        id: 50,
      },
    ],
  },
];

export const GeneralAgentAuthority = [
  ...AgentPermissions,
  {
    icon: "brand",
    name: "代理列表",
    componentPath: "/agent-home",
    type: "MENU",
    sortNo: 4,
    parentId: 0,
    id: 4,
    children: [
      {
        icon: "brand",
        name: "代理列表",
        componentPath: "/dashboard/agent-home.vue",
        path: "/dashboard/agent-home",
        type: "MENU",
        sortNo: 1,
        parentId: 4,
        id: 40,
      },
    ],
  },
];
